<script setup lang="ts">
import { Refresh } from "@element-plus/icons-vue";

const props = defineProps<{
  size?: "default" | "small" | "large";
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <el-button
    :icon="Refresh"
    title="Click to refresh"
    :size="props.size || 'default'"
    @click="emit('click')"
  >
    Refresh
  </el-button>
</template>

<style lang="less"></style>
